"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var classnames_1 = __importDefault(require("classnames"));
var Tooltip_1 = __importDefault(require("../Tooltip/Tooltip"));
var react_router_dom_1 = require("react-router-dom");
var Badge = function (props) {
    var active = props.active, className = props.className, icon = props.icon, id = props.id, onClick = props.onClick, text = props.text, tooltip = props.tooltip, url = props.url;
    var content = url ? (react_1.default.createElement(react_router_dom_1.NavLink, { to: url, onClick: onClick, className: "link" }, text)) : (text);
    var badge = (react_1.default.createElement(BadgeWrapper, { id: id, className: (0, classnames_1.default)('badge', className, { link: onClick }), onClick: url ? undefined : onClick },
        react_1.default.createElement("span", { className: (0, classnames_1.default)('inner', { active: active }) },
            icon && react_1.default.createElement(BadgeIcon, null, icon),
            react_1.default.createElement("span", { className: "text" }, content))));
    if (tooltip) {
        return (react_1.default.createElement(Tooltip_1.default, { value: tooltip, className: className }, badge));
    }
    return badge;
};
exports.Badge = Badge;
var BadgeWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 0.92rem;\n  user-select: ", ";\n\n  a,\n  a:active,\n  a:not(.btn),\n  a:visited {\n    text-decoration: none;\n    cursor: pointer;\n  }\n\n  .link,\n  &.link {\n    cursor: pointer;\n  }\n\n  .text {\n    font-size: 0.9rem;\n    vertical-align: baseline;\n  }\n\n  ", "\n"], ["\n  font-size: 0.92rem;\n  user-select: ", ";\n\n  a,\n  a:active,\n  a:not(.btn),\n  a:visited {\n    text-decoration: none;\n    cursor: pointer;\n  }\n\n  .link,\n  &.link {\n    cursor: pointer;\n  }\n\n  .text {\n    font-size: 0.9rem;\n    vertical-align: baseline;\n  }\n\n  ", "\n"])), function (props) { return (props.onClick ? 'pointer' : 'none'); }, function (props) {
    return (props.onClick || props.url) && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      .inner {\n        color: ", ";\n        transition: 0.3s color;\n\n        &.active,\n        :hover {\n          color: unset;\n        }\n\n        &.active {\n          font-weight: bold;\n          color: ", ";\n        }\n      }\n    "], ["\n      .inner {\n        color: ", ";\n        transition: 0.3s color;\n\n        &.active,\n        :hover {\n          color: unset;\n        }\n\n        &.active {\n          font-weight: bold;\n          color: ", ";\n        }\n      }\n    "])), props.theme.primaryBtn1HoverBg, props.theme.primaryBtn1Bg);
});
var BadgeIcon = styled_components_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-right: 5px;\n"], ["\n  margin-right: 5px;\n"])));
exports.default = exports.Badge;
var templateObject_1, templateObject_2, templateObject_3;
